import common from "commons/languages/english";

const trans = {
  program_name: "DS Tourism",
  version: "3.3.5",
};

export default { ...common, ...trans };
